import { gql } from '@apollo/client';

export const DATE_TIME_SLOTS_QUERY = gql`
  query dateTimeSlots(
    $appointmentTypeId: Int!
    $locationId: Int
    $startDateTime: String!
    $endDateOffsetInMonths: Int
    $endDateTime: String
    $labId: Int
    $providerId: Int
    $appointmentId: Int
    $filter: TimeslotFilterEnum
  ) {
    dateTimeSlots(
      appointmentTypeId: $appointmentTypeId
      locationId: $locationId
      startDateTime: $startDateTime
      endDateOffsetInMonths: $endDateOffsetInMonths
      endDateTime: $endDateTime
      labId: $labId
      providerId: $providerId
      appointmentId: $appointmentId
      filter: $filter
    ) {
      id
      startTime
      endTime
      timeZone
      videoLink
      virtualAppointment
      appointmentTypeId
      licensedProviderName
      lab {
        id
      }
    }
  }
`;
